import { fadeInModal } from "animations";
import { motion } from "motion/react";
import { useState } from "react";
import { checkMarkSvg, deleteSvg } from "svg";
import { useMobile } from "context/MobileContext";

function PinEntry({ setEmployee, text, onClose }) {
  const [pin, setPin] = useState("");
  const [isError, setError] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const { phone } = useMobile();

  const pinMap = {
    22: "Quinn",
    16: "Teague",
    "00": "Denise",
    17: "Miguel",
    3: "Juan",
    23: "Rob",
    55: "Teague",
  };

  const onSubmit = () => {
    if (pin in pinMap) setEmployee(pinMap[pin]);
    else {
      setPin("");
      setError(true);
    }
  };

  const pinButton = (num) => {
    const handleClick = () => {
      if (isError) setError(false);
      setPin(`${pin}${num}`);
      setActiveButton(num);
      setTimeout(() => setActiveButton(null), 150);
    };

    return (
      <div
        className={`pin-button ${activeButton === num ? "active" : ""}`}
        onClick={() => handleClick()}
      >
        {num}
      </div>
    );
  };

  const deleteButton = () => {
    return (
      <div className="pin-button" onClick={() => setPin(pin.slice(0, -1))}>
        {deleteSvg()}
      </div>
    );
  };

  const submitButton = () => {
    return (
      <div className="pin-button pin-button-submit" onClick={onSubmit}>
        {checkMarkSvg()}
      </div>
    );
  };

  const pinDisplay = () => {
    if (isError)
      return (
        <div
          style={{
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            color: "var(--red)",
            fontSize: "24px",
          }}
        >
          Incorrect Pin
        </div>
      );
    if (pin.length === 0)
      return (
        <div
          style={{
            height: "50px",
            fontWeight: "600",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            fontSize: "24px",
          }}
        >
          Enter your pin
        </div>
      );
    return (
      <div
        style={{
          height: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {pin.split("").map((_, i) => (
          <div key={i} className="pin-dot" />
        ))}
      </div>
    );
  };

  return (
    <motion.div
      className="res-modal-container pin-entry"
      style={{ gap: "2rem", paddingBottom: "4rem" }}
      {...fadeInModal}
      onClick={(e) => e.stopPropagation()}
    >
      {phone && onClose && (
        <button className="pin-close-btn" onClick={onClose}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 6L18 18" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ marginInline: "auto", fontSize: "20px" }}> {text} </div>
        {pinDisplay()}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <div className="pin-grid">
          {[...Array(9)].map((_, i) => pinButton(i + 1))}
          {deleteButton()}
          {pinButton(0)}
          {submitButton()}
        </div>
      </div>
    </motion.div>
  );
}

export default PinEntry;
